import { render, staticRenderFns } from "./FCMTemplatesPage.vue?vue&type=template&id=78f78bfa&"
import script from "./FCMTemplatesPage.vue?vue&type=script&lang=js&"
export * from "./FCMTemplatesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports